import { render, staticRenderFns } from "./MainFoot.vue?vue&type=template&id=668b80c2&scoped=true"
import script from "./MainFoot.vue?vue&type=script&lang=js"
export * from "./MainFoot.vue?vue&type=script&lang=js"
import style0 from "./MainFoot.vue?vue&type=style&index=0&id=668b80c2&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668b80c2",
  null
  
)

export default component.exports